// extracted by mini-css-extract-plugin
export default {"modal_overlay":"Modal_modal_overlay__Z8kwI","modal_box":"Modal_modal_box__cnDYL"};